import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { isoToBrDate } from '@/features/Vacations/utils/vacationDates';
import type { SegmentLockReason, VacationSegmentData } from '../clientApprovalPage.types';
import { LOCK_REASON_LABELS, LOCKED_FALLBACK_LABEL } from '../clientApprovalPage.definitions';

interface ClientPeriodChoicesProps {
    title: string;
    segments: VacationSegmentData[];
    lockedOrders: number[];
    lockedBy: Partial<Record<number, SegmentLockReason>>;
    responses: Record<number, boolean>;
    onChange: (order: number, approved: boolean) => void;
    disabled: boolean;
}

export function ClientPeriodChoices({ title, segments, lockedOrders, lockedBy, responses, onChange, disabled }: ClientPeriodChoicesProps) {
    return (
        <div className="bg-white p-4 rounded border border-gray-200">
            <p className="block text-sm font-semibold text-gray-900 mb-3">{title}</p>
            <div className="space-y-2">
                {segments.map((segment) => {
                    const lockReason = lockedBy[segment.order];
                    const isLocked = lockedOrders.includes(segment.order);
                    const periodText = `${isoToBrDate(segment.startDate)} a ${isoToBrDate(segment.endDate)} (${segment.days} dias)`;

                    if (isLocked) {
                        return (
                            <div key={segment.order} className="flex items-center gap-3 text-gray-500">
                                <CheckCircleIcon className="h-4 w-4 text-green-600" aria-hidden="true" />
                                <span className="text-sm">{periodText}</span>
                                <span className="ml-auto rounded bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700">
                                    {lockReason ? LOCK_REASON_LABELS[lockReason] : LOCKED_FALLBACK_LABEL}
                                </span>
                            </div>
                        );
                    }

                    return (
                        <label key={segment.order} className="flex items-center gap-3">
                            <input
                                type="checkbox"
                                disabled={disabled}
                                checked={responses[segment.order] ?? true}
                                onChange={(event) => onChange(segment.order, event.target.checked)}
                                className="w-4 h-4"
                            />
                            <span className="text-sm text-gray-700">{periodText}</span>
                        </label>
                    );
                })}
            </div>
        </div>
    );
}
